import React from 'react';
import { useScrollReveal } from '@/hooks/useScrollReveal';

interface RevealBlockProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
}

const RevealBlock = ({ children, className = '', delay = 0 }: RevealBlockProps) => {
  const { ref, visible } = useScrollReveal();
  return (
    <div
      ref={ref}
      className={`transition-all duration-700 ease-out ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'} ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
};

export default RevealBlock;
